import React from "react";
import { Nav } from "react-bootstrap";
import classNames from "classnames";
import { Location } from "history";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import css from "./BillTabs.module.css";
import { billsSelector } from "../../_redux/billsSlice";

export default function BillTabs() {
  const { pathname } = useLocation<Location>();
  const { currentBill } = useSelector(billsSelector);

  if (!currentBill) return null;

  return (
    <Nav variant="tabs" activeKey={pathname}>
      <Nav.Item>
        <Nav.Link
          as={Link}
          to={`/bills/${currentBill.id}`}
          eventKey={`/bills/${currentBill.id}`}
        >
          {currentBill.name}
        </Nav.Link>
      </Nav.Item>

      {(currentBill.documents || []).map((d, i) => (
        <React.Fragment key={d.id}>
          <Nav.Item className={classNames({ [css.rightTabGroup]: i === 0 })}>
            <Nav.Link
              as={Link}
              eventKey={`/bills/${currentBill.id}/documents/${d.id}`}
              to={`/bills/${currentBill.id}/documents/${d.id}`}
            >
              {d.name}
            </Nav.Link>
          </Nav.Item>
        </React.Fragment>
      ))}
    </Nav>
  );
}
